export default __webpack_public_path__ + "static/media/receiving-transfer-eksternal1.e7312c13.png";